export const ADDRESS_REQUEST_SUCCESS = 'ADDRESS_REQUEST_SUCCESS'
export const ADDRESS_REQUEST = 'ADDRESS_REQUEST'

export function validateAddress(
  firstName = 'noname',
  lastname = 'noname',
  address,
  city,
  state,
  postalCode,
  countyCode
) {
  return (dispatch) => {
    dispatch({
      type: ADDRESS_REQUEST,
    })
    window
      .fetch(
        `https://personator.melissadata.net/v3/WEB/ContactVerify/doContactVerify?&id=aqbiZT7WuuxQa2_mhDaNdj**&act=Check,Verify&cols=&opt=&first=${firstName}&last=${lastname}&full=&a1=${address}&a2=&city=${city}&state=${state}&postal=${postalCode}&ctry=&lastline=&bday=&bmo=&byr=&ss=&phone=&email=&mak=&comp=&ip=&ff=&format=JSON`
      )
      .then((response) => response.json().then((data) => ({ data, response })))
      .then(({ data, response }) => {
        dispatch({
          type: ADDRESS_REQUEST_SUCCESS,
          data,
          response,
        })
      })
  }
}
